import React, {Component} from "react";
import {Col, message, Row} from "antd";
import {connect} from "react-redux";
import SlideList from "../component/dashboard/slidelist";
import {updateSearchRelatedMetaData, updateUrlStateInReducer} from '../redux_actions/search.action'
import cookie from 'react-cookies';
import '../asset/style/dashboard.css';
import TawkBot from "../component/gammaviewer/components/tawkBot";
import {componentIds, openInNewTabType, responsiveLayers} from "../utils/const";
import {isTrue} from "../utils/utils";
import {checkAbstractAppPermission, getAbstractApps} from "../component/utils/abstract_app_maker";
import ShareModal from "../component/utils/shareModal";
import {addSlidesToPoller, clearPoller} from "../redux_actions/dashboard.action";

class AllScansView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			initValue: "&nbsp",
		};
		this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
			(document.documentElement.clientWidth < document.documentElement.clientHeight);

		this.props.dispatch(updateUrlStateInReducer(this.props.urlStateDashboard));
		!this.isMobile && this.props.dispatch(updateSearchRelatedMetaData());

		// Destroys all pending messages
		message.destroy();
	}

    componentDidMount() {
		getAbstractApps().filter(app => checkAbstractAppPermission(app))
    }

	componentWillUnmount() {
		this.props.dispatch(clearPoller());
	}


	render() {

        let tawkBot = null;
        if (cookie.loadAll().tawk_bot === "true") {
            tawkBot = <TawkBot/>;
        }

		return (
			<div className="dashboard">
				<Row>
					<Col span={24} className={isTrue(cookie.load("isMobile")) ? "all-slides-mobile" : "all-slides"}
						 id="all-slides">
						<SlideList/>
					</Col>
				</Row>
				<Row>
					<div id={componentIds.tawkIntegration}>
						{/*style={{position: 'absolute', top: 60, right: '2.4vw', zIndex: 2}}*/}
						{tawkBot}
					</div>
                </Row>
                {this.props.slideModalOpen ? <ShareModal type={openInNewTabType.SLIDE}/> : null}
			</div>
		);
	}
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginAlerts.loginStatus,
        allSlides: state.slidesReducer,
        numPages: state.dashboardReducer.numPages,
        pageNumber: state.dashboardReducer.pageNumber,
        urlStateDashboard: state.searchReducer,
		slideModalOpen: state.shareManagerReducer.slideModalOpen,
        tourActive: state.websiteTourReducer.tourActive,
	    tourActiveForScan: state.websiteTourReducer.tourActiveForScan,
    };
};

export default connect(mapStateToProps)(AllScansView);
